module.exports = __webpack_public_path__ + "static/media/accounting-analytics.ac7e330d.jpg";